import React from 'react';
import { Grid, Typography, Box, useTheme } from '@material-ui/core';

const SectionHeader = ({ title, lineBottom, id }) => {
  const theme = useTheme();
  return (
    <Grid container justify="center" id={id}>
      <Grid item>
        <Typography
          variant="h6"
          align="center"
          style={{
            marginTop: '24px',
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        {lineBottom && (
          <Box
            style={{ background: `${theme.palette.secondary.main}` }}
            width="150px"
            height="4px"
            borderRadius="2px"
            mt="4px"
            mb="24px"
          />
        )}
      </Grid>
    </Grid>
  );
};

export { SectionHeader };
